import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortDown } from '@fortawesome/free-solid-svg-icons';

import { Popover, Button, Typography } from '@material-ui/core';
import Link from './Link';
import ModalPrint from './ModalPrint';
import ModalInactive from './ModalInactive';

export default ({ action, domain, student }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <span>
            <a style={{ cursor: 'pointer' }} aria-describedby={id} onClick={handleClick}>
                {action.label}
            </a>{' '}
            <FontAwesomeIcon style={{ position: 'relative', top: '-.15em' }} icon={faSortDown} />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <ul className={`actions`}>
                    {action.options.map((option, key) => (
                        <li key={`${option.label}_${key}`}>
                            {
                                {
                                    link: <Link action={option} domain={domain} />,
                                    modalPrint: <ModalPrint handleClose={handleClose} action={option} domain={domain} student={student} />,
                                    modalInactive: <ModalInactive handleClose={handleClose} action={option} domain={domain} student={student} />,
                                }[option.type]
                            }
                        </li>
                    ))}
                </ul>
            </Popover>
        </span>
    );
};
